import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { CotacaoDTO } from '../../models/gerenciar-contas/cotacao.model';

/**
 * Payload emitido pelo dialogo de cotacao.
 * `pesoGuarani` e opcional para preservar retrocompatibilidade com cotacoes
 * antigas que nao carregam o par ARS x PYG.
 * `cotacao` e a cotacao devolvida pelo POST /cotacao (com id).
 */
export interface CotacaoSalvaPayload {
  dolarGuarani: number;
  realGuarani: number;
  dolarReal: number;
  pesoGuarani?: number | null;
  cotacao?: CotacaoDTO | null;
}

/**
 * Opcoes de abertura do dialogo global de cotacao. Todas opcionais: sem elas o
 * dialogo mantem o comportamento historico (empresa/moeda da sessao, subtitulo
 * "cotacao desatualizada").
 */
export interface AbrirCotacaoDialogOpts {
  /** Empresa dona da cotacao (ex.: cliente na Area do Contador). */
  empresaId?: number | null;
  /** Moeda padrao da empresa dona da cotacao. */
  moedaEmpresa?: string | null;
  /** Chave i18n do subtitulo (ex.: 'cotacao_dialog.subtitulo_nao_cadastrada'). */
  subtituloChave?: string | null;
}

/**
 * Servico para comunicacao entre componentes sobre o dialogo global de cotacao.
 * Permite que qualquer componente solicite a abertura do dialogo
 * e seja notificado quando uma cotacao for salva (ou o dialogo for cancelado).
 */
@Injectable({
  providedIn: 'root',
})
export class CotacaoDialogService {
  private abrirDialogSubject = new Subject<AbrirCotacaoDialogOpts | undefined>();
  private cotacaoSalvaSubject = new Subject<CotacaoSalvaPayload>();
  private cotacaoCanceladaSubject = new Subject<void>();

  /** Observable para solicitar abertura do dialogo */
  abrirDialog$: Observable<AbrirCotacaoDialogOpts | undefined> = this.abrirDialogSubject.asObservable();

  /** Observable emitido quando uma cotacao e salva com sucesso */
  cotacaoSalva$: Observable<CotacaoSalvaPayload> = this.cotacaoSalvaSubject.asObservable();

  /** Observable emitido quando o usuario fecha o dialogo sem salvar */
  cotacaoCancelada$: Observable<void> = this.cotacaoCanceladaSubject.asObservable();

  /** Solicita abertura do dialogo global de cotacao */
  abrirDialog(opts?: AbrirCotacaoDialogOpts): void {
    this.abrirDialogSubject.next(opts);
  }

  /** Notifica que uma cotacao foi salva */
  notificarCotacaoSalva(valores: CotacaoSalvaPayload): void {
    this.cotacaoSalvaSubject.next(valores);
  }

  /** Notifica que o dialogo foi fechado sem salvar */
  notificarCotacaoCancelada(): void {
    this.cotacaoCanceladaSubject.next();
  }
}
